import component from './component';
import wizard from './wizard';
import wizardHeader from './wizardHeader';
import wizardNav from './wizardNav';

const coreQuestionnaire = {
  component,
  wizard,
  wizardHeader,
  wizardNav,
};

export default coreQuestionnaire;
